import { render, staticRenderFns } from "./PermissionManagementPage.vue?vue&type=template&id=07377a06&scoped=true"
import script from "./PermissionManagementPage.vue?vue&type=script&lang=js"
export * from "./PermissionManagementPage.vue?vue&type=script&lang=js"
import style0 from "./PermissionManagementPage.vue?vue&type=style&index=0&id=07377a06&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07377a06",
  null
  
)

export default component.exports